import React from 'react'
import styles from '../AdminPanelPage.module.scss'
import OperatorsList from './OperatorsList'
import DriversList from './DriversList'
import BranchesList from './BranchesList'
import MiniMap from 'pages/ReportCard/MiniMap'

const TopBasesPanel = ({
  topBasesFilter,
  setTopBasesFilter,
  filteredTopBases,
  topBasesPagination,
  loadTopBasesPage,
  openCreateModal,
  startEdit,
  editingTopBase,
  editPayloads,
  setEditPayloads,
  saveEdit,
  cancelEdit,
  expandedTopBase,
  setExpandedTopBase,
  expandedOperatorsTopBase,
  setExpandedOperatorsTopBase,
  expandedDriversTopBase,
  setExpandedDriversTopBase,
  expandedBranchesTopBase,
  setExpandedBranchesTopBase,
  loadOperatorsByTopBasePage,
  loadDriversByTopBasePage,
  loadBranchesByTopBasePage,
  operatorsByTopBase,
  driversByTopBase,
  branchesByTopBase,
  operatorsPaginationByTopBase,
  driversPaginationByTopBase,
  branchesPaginationByTopBase,
  operatorsFilterByTopBase,
  driversFilterByTopBase,
  branchesFilterByTopBase,
  setOperatorsFilterByTopBase,
  setDriversFilterByTopBase,
  setBranchesFilterByTopBase,
  employees,
  editingOperatorByTopBase,
  editingDriverByTopBase,
  editingBranchByTopBase,
  startEditOperator,
  startEditDriver,
  startEditBranch,
  saveEditOperator,
  saveEditDriver,
  saveEditBranch,
  cancelEditOperator,
  cancelEditDriver,
  cancelEditBranch,loadOperators,
  loadDriversByTopBase,
  expandedDriverByTopBase,
  toggleDriver,
  expandedOperatorByTopBase,
  toggleOperator,
  printDriverPass,
  downloadDriverPass,
  topBases,
  chpps = [],
  privatePoints = []
}) => {
  return (
    <div className={styles.panel}>
      <div className={styles.panelHeader}>
        <div className={styles.panelTitle}>Окно: ТОП-Базы</div>
        <div>
          <button className={styles.addButton} onClick={() => openCreateModal('topbase')}>Добавить ТОП-Базу</button>
        </div>
      </div>
      <div className={styles.panelBody}>
        <div className={styles.searchRow}>
          <input className={styles.searchInput} placeholder="Поиск..." value={topBasesFilter} onChange={(e) => setTopBasesFilter(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') loadTopBasesPage(1, topBasesFilter) }} />
        </div>
        {filteredTopBases && filteredTopBases.length ? (
          <table className={styles.table}>
            <thead>
              <tr>
                <th>№</th>
                <th>Название</th>
                <th>Телефон</th>
                <th>Местоположение</th>
                <th>Действия</th>
              </tr>
            </thead>
            <tbody>
              {filteredTopBases.map((tb, index) => (
                <React.Fragment key={tb.id}>
                  <tr className={styles.topBaseRow}>
                    <td>{index + 1}</td>
                    <td className={styles.topBaseTitle} onClick={() => { const newVal = (expandedTopBase === tb.id ? null : tb.id); setExpandedTopBase(newVal); if (newVal) loadOperatorsByTopBasePage(tb.id, 1); }}>{tb.name}</td>
                    <td>{tb.phone || '-'}</td>
                    <td>
                      {tb.geo ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexDirection: 'column' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <button 
                              onClick={() => window.open(`https://www.google.com/maps?q=${tb.geo}`, '_blank')} 
                              className={styles.geoLinkBtn}
                              title="Открыть в Google Maps"
                            >
                              🗺️ Карты
                            </button>
                            <button 
                              onClick={() => {
                                const elem = document.getElementById(`map-${tb.id}`);
                                if (elem) elem.style.display = elem.style.display === 'none' ? 'block' : 'none';
                              }} 
                              className={styles.mapToggleBtn}
                              title="Показать/скрыть карту"
                            >
                              📌
                            </button>
                          </div>
                          <div id={`map-${tb.id}`} style={{ width: 200, height: 150, display: 'none' }}>
                            <MiniMap geo={tb.geo} />
                          </div>
                        </div>
                      ) : '-'}
                    </td>
                    <td>
                      <button className={styles.smallBtn} onClick={() => { const newVal = (expandedBranchesTopBase === tb.id ? null : tb.id); setExpandedBranchesTopBase(newVal); if (newVal) loadBranchesByTopBasePage(tb.id, 1); setExpandedTopBase(tb.id); }}>Филиалы</button>
                      <button className={styles.smallBtn} onClick={() => { const newVal = (expandedOperatorsTopBase === tb.id ? null : tb.id); setExpandedOperatorsTopBase(newVal); if (newVal) loadOperatorsByTopBasePage(tb.id, 1); setExpandedTopBase(tb.id); }}>Операторы</button>
                      <button className={styles.smallBtn} onClick={() => { const newVal = (expandedDriversTopBase === tb.id ? null : tb.id); setExpandedDriversTopBase(newVal); if (newVal) loadDriversByTopBasePage(tb.id, 1); setExpandedTopBase(tb.id); }}>Водители</button>
                      <button className={styles.smallBtn} style={{ marginLeft: 8 }} onClick={() => startEdit('topbase', tb.id, { name: tb.name, phone: tb.phone })}>Изменить</button>
                    </td>
                  </tr>
                  {editingTopBase === tb.id && (
                    <tr>
                      <td colSpan={5}>
                        <div style={{ padding: 8 }}>
                          <label>Название</label>
                          <input value={(editPayloads[`topbase__${tb.id}`] || {}).name || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`topbase__${tb.id}`]: { ...p[`topbase__${tb.id}`], name: e.target.value } }))} />
                          <label style={{ marginLeft: 8 }}>Телефон</label>
                          <input value={(editPayloads[`topbase__${tb.id}`] || {}).phone || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`topbase__${tb.id}`]: { ...p[`topbase__${tb.id}`], phone: e.target.value } }))} />
                          <div style={{ marginTop: 8 }} className={styles.navbattons}>
                            <button className={styles.btn_pin} onClick={() => saveEdit('topbase', tb.id)}>Сохранить</button>
                            <button className={styles.btn_pin_close} style={{ marginLeft: 8 }} onClick={() => cancelEdit('topbase', tb.id)}>Отмена</button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                  {expandedTopBase === tb.id && (
                    <tr>
                      <td colSpan={5}>
                        <div className={styles.operatorsList}>
                          {expandedOperatorsTopBase === tb.id && (
                            <OperatorsList
                              tb={tb}
                              operators={operatorsByTopBase[tb.id]}
                              operatorsFilter={operatorsFilterByTopBase[tb.id]}
                              setOperatorsFilter={(v) => setOperatorsFilterByTopBase(prev => ({ ...prev, [tb.id]: v }))}
                              loadOperatorsByTopBasePage={loadOperatorsByTopBasePage}
                              employees={employees}
                              openCreateModal={openCreateModal}
                              editingOperatorByTopBase={editingOperatorByTopBase}
                              editPayloads={editPayloads}
                              setEditPayloads={setEditPayloads}
                              startEdit={startEditOperator}
                              saveEdit={saveEditOperator}
                              cancelEdit={cancelEditOperator}
                              operatorsPagination={operatorsPaginationByTopBase[tb.id]}
                              expandedOperatorByTopBase={expandedOperatorByTopBase}
                              toggleOperator={toggleOperator}
                            />
                          )}

                          {expandedDriversTopBase === tb.id && (
                            <DriversList
                              tb={tb}
                              drivers={driversByTopBase[tb.id]}
                              driversFilter={driversFilterByTopBase[tb.id]}
                              setDriversFilter={(v) => setDriversFilterByTopBase(prev => ({ ...prev, [tb.id]: v }))}
                              loadDriversByTopBasePage={loadDriversByTopBasePage}
                              employees={employees}
                              editingDriverByTopBase={editingDriverByTopBase}
                              editPayloads={editPayloads}
                              setEditPayloads={setEditPayloads}
                              startEdit={startEditDriver}
                              saveEdit={saveEditDriver}
                              openCreateModal={openCreateModal}
                              cancelEdit={cancelEditDriver}
                              driversPagination={driversPaginationByTopBase[tb.id]}
                              expandedDriverByTopBase={expandedDriverByTopBase}
                              toggleDriver={toggleDriver}
                              printDriverPass={printDriverPass}
                              downloadDriverPass={downloadDriverPass}
                              topBases={topBases}
                              chpps={chpps}
                              privatePoints={privatePoints}
                            />
                          )}

                          {expandedBranchesTopBase === tb.id && (
                            <BranchesList
                              base={tb}
                              baseType="ТОП-базы"
                              branches={branchesByTopBase[tb.id]}
                              branchesFilter={branchesFilterByTopBase[tb.id]}
                              setBranchesFilter={(v) => setBranchesFilterByTopBase(prev => ({ ...prev, [tb.id]: v }))}
                              loadBranchesByBasePage={loadBranchesByTopBasePage}
                              openCreateModal={openCreateModal}
                              editingBranchByBase={editingBranchByTopBase}
                              editPayloads={editPayloads}
                              setEditPayloads={setEditPayloads}
                              startEdit={startEditBranch}
                              saveEdit={saveEditBranch}
                              cancelEdit={cancelEditBranch}
                              branchesPagination={branchesPaginationByTopBase[tb.id]}
                            />
                          )}
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        ) : (
          <div>Список ТОП-баз пуст</div>
        )}
        {(!topBasesFilter && topBasesPagination && topBasesPagination.count > 0) && (
          <div className={styles.pagination}>
            <button disabled={!topBasesPagination.previous} onClick={() => loadTopBasesPage((topBasesPagination.page || 1) - 1)}>Пред.</button>
            <span>Стр. {topBasesPagination.page || 1} — Всего: {topBasesPagination.count}</span>
            <button disabled={!topBasesPagination.next} onClick={() => loadTopBasesPage((topBasesPagination.page || 1) + 1)}>След.</button>
          </div>
        )}
      </div>
    </div>
  )
}

export default TopBasesPanel
